module.exports = __webpack_public_path__ + "assets/img/parent_register_without_monkey.2749beba.png";